/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "_*" }]*/

export function FlatIndexToSpatialIndices(m, n, index) {
  /**
   * Converts an index of a flat array (0 indexed) to indices i, j for a 2-D array
   */
  return [Math.floor(index/n), index%n];
}

export function IndicesFromKey(key) {
  const [_, x, y, ..._rest] = [...key.matchAll(/\((-?\d+),(-?\d+)\)/g)][0];
  return [x, y].map(v => parseInt(v));
}

export function ApplyRotation([x, y], angle) {
  switch(angle) {
    case 0:
      return [x, y];
    case 90:
      return [-y, x];
    case 180:
      return [-x, -y];
    case 270:
      return [y, -x];
    default:
      throw Error("unexpected angle");
  }
}
export function GenerateResources(shape, fillPercent) {
  const [m, n] = shape;
  const size = m * n;
  let mapObjects = {};

  const min = 1;
  const max = 3;

  // Generate size * fillPercent% random locations to place resources
  for (let index = 0; index < Math.floor(size * fillPercent / 100); index++) {
    const i = Math.floor(Math.random() * m);
    const j = Math.floor(Math.random() * n);
    const key = `(${i},${j})`;

    // Check if there is already something at that spot
    // Regenerate if so
    if (mapObjects.hasOwnProperty(key)) {
      index -= 1;
      continue;
    }

    const available = Math.floor(Math.random() * (max - min + 1) + min);

    mapObjects = {
      ...mapObjects, [key]: {
        'type': 'resource',
        'available': available,
        'left': available,
        'multiplier': 1 + 0.1*available,
      }
    };
  }

  return mapObjects;
}
